<template>
  <div class="dn-box flex justify-center items-center whitespace-normal text-base
              w-auto h-auto p-2 border rounded-md
              sm:text-lg md:text-xl ">
    <div class="dn-chart flex justify-center items-center">
      <pie-chart :chart-id="id" ref="pieChart" :pie-data="pieValues" :pie-labels="labels" :options="pieOptions"
                 :width="60"
                 :height="60"></pie-chart>
      <div v-if="percent" class="dn-percent absolute text-base text-blue-600">{{ calculatedPercent }}</div>
    </div>
    <dl class="dn-text flex-auto px-2">
      <dt class="dn-title text-base text-blue-600" v-html="title"></dt>
      <dd class="dn-description text-gray-600" v-html="description"></dd>
    </dl>
  </div>
</template>

<script>
export default {
  name: "doughnut-stat-box",
  props: {
    id: {type: String, required: false},
    title: {type: String, required: true},
    description: {type: String, required: true},
    values: {type: Array | Object, required: true},
    labels: {type: Array, required: true},
    percent: {type: Boolean, required: false},
    chartOptions: {type: Object, required: false}
  },
  data() {
    return {
      myValues: this.values,
      myLabels: this.labels
    }
  },
  watch: {
    $props: {
      immediate: true,
      deep: true,
      handler() {
        if (this.validateProps()) {
          if (this.$refs.pieChart) {
            this.$refs.pieChart.render();
          }
        }
      }
    },
    values(newVal) {
      this.myValues = newVal;
      this.myValues.max = newVal.max === 0 ? 100 : newVal.max;
    },
    labels(newval) {
      this.myLabels = newval;
      if (newval.length === 0) {
        this.myLabels = ['',''];
      } else if (newval.length === 1) {
        this.myLabels = [newval[0], ''];
      }
      console.log(this.myLabels);
    }
  },
  methods: {
    validateProps() {
      if (this.percent && Array.isArray(this.values)) {
        throw 'When percent prop is set, values prop should be object not array';
      } else if (this.percent && typeof this.values === 'object') {
        if (!this.values.hasOwnProperty('val') || !this.values.hasOwnProperty('max')) {
          throw 'Wrong values prop format, ie: {val: number, max: number}';
        } else if (this.values.val > this.values.max) {
          throw 'Wrong values prop format, "max" value should be greater than "val"';
        }
      }
      return true;
    }
  },
  computed: {
    pieValues() {
      return (this.percent) ? [this.myValues.val, (this.myValues.max - this.myValues.val)] : this.myValues;
    },
    pieOptions() {
      let defaultOpt = {
        cutoutPercentage: 70,
        legend: {display: false},
        tooltips: {enabled: false},
        responsive: false,
        maintainAspectRatio: true
      };
      return {...defaultOpt, ...this.chartOptions};
    },
    calculatedPercent() {
      let percent = '';
      if (this.percent) {
        let total = this.myValues.max;
        let value = this.myValues.val;
        percent = (total > 0) ? Math.round((value * 100) / total) + "%" : '0%';
      }
      return percent;
    }
  }
}
</script>

<style scoped>

</style>